import SingleTransportTypeContent
    from "@SearchResults/features/staticContent/features/singleModal/components/SingleTransportTypeContent";
import useSearchResults from "@SearchResults/hooks/useSearchResults";
import handleTransportTypes from "@SearchResults/features/staticContent/functions/handleTransportTypes";
import MultipleTransportTypeContent
    from "@SearchResults/features/staticContent/features/multiModal/components/MultipleTransportTypeContent";

function StaticContent() {
    const {data, isLoading} = useSearchResults()

    if (!data) {
        return (
            <>
            </>
        )
    }

    const {
        hasMoreThanOneTransportType,
        transportTypes,
    } = handleTransportTypes(data)

    const {result: {resolvedApiCount, totalApiCount, failedApiCount}} = data

    if (isLoading || totalApiCount > resolvedApiCount + failedApiCount || !transportTypes.length) {
        return (
            <>
            </>
        )
    }

    return (
        <section className="gb--search-results__static-content">
            {hasMoreThanOneTransportType ? (
                <MultipleTransportTypeContent
                    transportTypes={transportTypes}
                />
            ) : (
                <SingleTransportTypeContent
                    transportType={transportTypes[0]}
                />
            )}
        </section>
    )
}

export default StaticContent